/* eslint-disable react/jsx-props-no-spreading */
import React, { FC, ReactElement, TextareaHTMLAttributes } from 'react';
import { cn } from 'src/domains/common/components/utils';
import { observer } from 'src/utils/mobx-react';
import { FormInputState } from 'src_common/common/mobx-utils/Form2/FormInputState';

// Input

export interface TextAreaType extends TextareaHTMLAttributes<HTMLTextAreaElement> {
    label?: string;
    dataTest?: string;
    textLimit?: number;
    formInputState: FormInputState<string, unknown>;
    errors: string[];
}

export const TextArea: FC<TextAreaType> = observer(
    'TextArea',
    ({ label, formInputState, className, dataTest, textLimit, errors, ...props }): ReactElement => {
        const error = errors.length === 0 ? null : errors[0] ?? null;
        const handleChangle = (value: string): void => {
            const limitedValue = textLimit === undefined ? value : value.slice(0, textLimit);
            formInputState.setValueOnChange(limitedValue);
        };
        return (
            <div className='flex flex-col gap-2'>
                {label !== undefined && <label className={cn('text-sm')}>{label}</label>}
                <textarea
                    value={formInputState.value}
                    onChange={(e): void => handleChangle(e.target.value)}
                    className={cn(
                        'flex w-full rounded-md border border-solid border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium text-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 h-[120px] font-tertiary',
                        error === null ? '' : 'border-destructive',
                        className
                    )}
                    style={{ resize: 'none' }}
                    data-test={dataTest}
                    {...props}
                />
                {textLimit !== undefined && (
                    <span className='text-sm text-muted-foreground'>
                        {formInputState.value.length}/{textLimit}
                    </span>
                )}
                {error === null ? null : <span className='text-sm text-destructive'>{error}</span>}
            </div>
        );
    }
);
